/********************************************
 * Logos Ticker
 ********************************************/
function fnLogosTicker(i, oSection) {

    /*****************
     * Objects
     *****************/
    var oSection = $(oSection),
        oLogos = $('.logos', oSection);

    /*****************
     * Slick configuration
     *****************/
    if (oLogos.find('.logo').length > 6) {
        oLogos.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            focusOnSelect: false,
            pauseOnHover: false,
            autoplay: true,
            infinite: true,
            autoplaySpeed: 2000,
            speed: 600,
            centerPadding: '15vw',
            centerMode: true,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '25vw',
                    }
                },
            ]
        });
    }
}



// END OF DOCUMENT
